//
import AssetDiscountModel from '@/models/HumanResource/HrAssetDiscount'
import ContractPeriodModel from '@/models/HumanResource/HrContractPeriod'
import ContractTypeModel from '@/models/HumanResource/HrContractType'
import EmployeeModel from '@/models/HumanResource/HrEmployee'

//
import AssetDiscountHeaders from '@/views/HumanResource/HrAssetDiscount/HrAssetDiscountHeaders'
import ContractHeadersCreate from '@/views/HumanResource/HrContract/partials/HrContractHeadersCreate'

//
import {
    NoZeroRule,
    NoNegativeRule,
    RequiredRule,
} from '@/mixins/reusable_mixins/rules'

//
export default [
    {
        name: 'hr_employee_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Empleado',
            model: EmployeeModel,
            noObject: true,
            paramSearch: 'names',
            rules: [RequiredRule],
        },
    },
    {
        name: 'hr_contract_type_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Plazo',
            model: ContractTypeModel,
            noObject: true,
            paramSearch: 'name',
            rules: [RequiredRule],
        },
    },
    {
        name: 'hr_contract_period_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Periodo',
            model: ContractPeriodModel,
            noObject: true,
            paramSearch: 'name',
            rules: [RequiredRule],
        },
    },
    {
        name: 'weekly_hours',
        type: 'float-field',
        props: {
            label: 'Horas semanales',
            reverse: true,
            rules: [NoNegativeRule],
        },
    },
    {
        name: 'base_salary',
        type: 'currency-field',
        props: {
            label: 'Monto Base',
            reverse: true,
            rules: [NoZeroRule],
        },
    },
    {
        name: 'collation',
        type: 'currency-field',
        props: {
            label: 'Colación',
            reverse: true,
            rules: [NoNegativeRule],
        },
    },
    {
        name: 'mobilization',
        type: 'currency-field',
        props: {
            label: 'Movilización',
            reverse: true,
            rules: [NoNegativeRule],
        },
    },
    {
        name: 'selected',
        type: 'table-field',
        flex: {
            xs12: true,
        },
        props: {
            headers: ContractHeadersCreate,
            noDataText: 'Sin haberes y descuentos.',
            pickerProps: {
                headers: AssetDiscountHeaders,
                mapper: row => {
                    //
                    row.periodic = true
                    row.new_periodic_month = '2019-01'
                    row.amount = 0
                    //
                    return row
                },
                noSearch: true,
                service: AssetDiscountModel,
            },
            showPicker: true,
            toolbarTitle: 'Haberes y descuentos',
        },
    },
    {
        name: 'init_date',
        type: 'date-field',
        props: {
            label: 'Inicio Contrato',
            rules: [RequiredRule],
        },
    },
    {
        name: 'end_date',
        type: 'date-field',
        props: {
            label: 'Fin Contrato',
        },
    },
    {
        name: 'vacations_since',
        type: 'date-field',
        props: {
            label: 'Inicio Vacaciones',
        },
    },
    {
        name: 'vacations_progressive_days',
        type: 'float-field',
        value: '',
        props: {
            label: 'Días Progresivos',
            reverse: true,
        },
    },
]
